var module = angular.module('octopusApp.shared');

module.directive('deploymentListing', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      deployments: '=',
      prefix: '@'
    },
    templateUrl: 'areas/shared/views/deployment-listing.html',
    controller: function($scope, octopusRepository, $q) {

      $scope.tasks = { };
      $scope.projects = { };
      $scope.releases = { };

      var completedTasks = {};

      var update = function() {
        if (!$scope.deployments) {
          return;
        }

        // We always want to refresh running tasks, but completed tasks can be cached
        var tasks = { };
        _.each(completedTasks, function (a,k) {
          tasks[k] = a;
        });

        var promises = [];

        _.each($scope.deployments.Items, function(dep) {
          if (!tasks[dep.TaskId]) {
            promises.push(octopusRepository.Tasks.get(dep.TaskId).then(function(task) {
              tasks[dep.TaskId] = task;
              if (task.IsCompleted) {
                // Cache the completed task for later
                completedTasks[dep.TaskId] = task;
              }
            }));
          }
          if (!$scope.projects[dep.ProjectId]) {
            promises.push(octopusRepository.Projects.get(dep.ProjectId).then(function(project) {
              $scope.projects[dep.ProjectId] = project;
            }));
          }
          if (!$scope.releases[dep.ReleaseId]) {
            promises.push(octopusRepository.Releases.get(dep.ReleaseId).then(function(release) {
              $scope.releases[dep.ReleaseId] = release;
            }));
          }
        });

        $q.all(promises).then(function () {
          $scope.tasks = tasks;
        });
      };

      $scope.$watch('deployments.Items', update);

      update();
    }
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/deployment_listing.js
// module id = 3526602257691067
// module chunks = 1